module.exports = __webpack_public_path__ + "a488d5b2.png";